export default {
  meta: {
    label: 'Swedish (svenska)'
  },
  data: {
    sv: {
      97: [['⚓️', 'ankare']],
      98: [
        ['🍌', 'banan'],
        ['👶', 'bebis'],
        ['🐙', 'bläckfisk'],
        ['🐝', 'bi'],
        ['📫', 'brevlåda'],
        '⚡️'
      ],
      99: [], //C
      100: [['💃', 'dansa'], ['🍇', 'druvor'], ['👸🏻', 'drottning']],
      101: [['🦄', 'enhörning']],
      102: [['👣', 'fötter'], ['🦇', 'fladdermus'], ['❓', 'frågetecken']],
      103: [
        ['🍦', 'glass'],
        ['🐸', 'groda'],
        ['🦍', 'gorilla'],
        ['🏐', 'garn'],
        ['🥘', 'stekpanna']
      ],
      104: [
        ['🐶', 'hund'],
        ['🥅', 'hockeymål'],
        ['🏒', 'hockeyklubba'],
        ['🐹', 'hamster']
      ],
      105: [],
      106: [['🤹🏼‍♀️', 'jonglerare'], ['👖', 'jeans'], ['🕹️', 'joystick']],
      107: [
        ['🐈', 'katt'],
        ['🐄', 'ko'],
        ['🔪', 'kniv'],
        ['🐇', 'kanin'],
        ['🦃', 'kalkon']
      ],
      108: [],
      109: [['🌝', 'moon'], ['👄', 'mun']],
      110: [['👃', 'näsa'], ['🎶', 'noter'], ['🔑', 'nyckel']],
      111: [['👌', 'okej'], ['🐍', 'orm']],
      112: [['🥞', 'pannkakor'], ['🍐', 'päron'], ['☂️', 'paraply']],
      113: [],
      114: [],
      115: [['👻', 'spöke'], ['🥗', 'sallad'], ['⭐️', 'stjärna']],
      116: [['🐆', 'tiger']],
      117: [['👽', 'utomjording']],
      118: [['🍉', 'vattenmelon'], ['🌊', 'våg'], ['🌋', 'vulkan']],
      119: [],
      120: [],
      121: [],
      122: []
    }
  }
};
